import React from 'react';
import { Typography } from '@mui/material';

// หัวข้อหลักของแต่ละหมวด — ตัวหนา ขีดเส้นใต้ พื้นหลังไล่สีอ่อนๆ ให้เด่นชัดแยกจากแถวข้อมูล
export function SectionHeader({ children }) {
  return (
    <Typography
      variant="subtitle2"
      sx={{
        display: 'block',
        fontWeight: 700,
        fontSize: '0.85rem',
        color: '#1e3a8a',
        bgcolor: '#eff6ff',
        px: 0.75,
        py: 0.15,
        mb: 0.3,
        mt: 0.6,
        borderRadius: 0.5,
        textDecoration: 'underline',
        textDecorationColor: '#93c5fd',
        textUnderlineOffset: '3px',
      }}
    >
      {children}
    </Typography>
  );
}
